import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Icon from './AppIcon';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = availableLanguages?.find(lang => lang?.code === currentLanguage);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white hover:bg-gray-50 transition-colors border border-gray-200"
        aria-label="Select language"
      >
        <span className="text-xl">{currentLang?.flag}</span>
        <span className="text-sm font-medium text-gray-700">
          {currentLang?.code?.split('-')?.[0]?.toUpperCase()}
        </span>
        <Icon 
          name={isOpen ? 'ChevronUp' : 'ChevronDown'} 
          size={16} 
          color="#374151" 
        />
      </button>
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50">
          {availableLanguages?.map((lang) => (
            <button
              key={lang?.code}
              onClick={() => handleLanguageChange(lang?.code)}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors ${
                currentLanguage === lang?.code
                  ? 'bg-blue-50 text-blue-600' :'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className="text-2xl">{lang?.flag}</span>
              <span className="text-sm font-medium flex-1">{lang?.label}</span>
              {currentLanguage === lang?.code && (
                <Icon name="Check" size={18} color="#2563eb" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;